import React from "react";
import SectionImg from "../../common/images/customsec_img.png";
import stepOne from "../../common/images/cstep1.png";
import stepTwo from "../../common/images/cstep2.png";
import stepThree from "../../common/images/cstep3.png";
const steps = [
  { img: stepOne, title: "Tailored to Your Business Needs", desc: "We build software from the ground up, ensuring it fits your specific business model and operational requirements." },
  { img: stepTwo, title: "Scalable and Flexible", desc: "We build software from the ground up, ensuring it fits your specific business model and operational requirements." },
  { img: stepThree, title: "Enhanced Performance and Security", desc: "We incorporate advanced security protocols and performance optimization strategies to deliver secure and efficient software solutions." },
];

const Section_one = () => {
  return (
    <div>
      <div
        className="relative bg-secondary  bg-cover bg-center bg-no-repeat text-white md:py-7 py-5 "
        style={{ backgroundImage: "url('/android-dot.png')" }}
      >
        {/* Main Heading */}
        <div className="max-w-[1280px] mx-auto text-center px-5 md:px-10 md:pt-7 md:pb-5 pt-0 pb-0">
          <h2 className="small:text-3xl text-2xl small:overflow-hidden small:whitespace-nowrap  small:animate-typing font-bold md:text-4xl ">
          Why Choose Custom Software Development?    </h2>{" "}
          <div className="underline small:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-primary">
            <p className="h-[5px] rounded-xl bg-primary w-[50%]"></p>
          </div>
          <p className="mx-auto small:w-[50%]">Off-the-shelf software often comes with limitations that prevent businesses from reaching their full potential. Our custom solutions are designed to align perfectly with your business goals and processes, ensuring seamless integration and maximum efficiency.</p>
        </div>

        {/* Image Below Paragraph */}
        <div className="mt-6 max-w-[1280px] mx-auto small:flex hidden justify-center">
          <img
            src={SectionImg}
            alt="Illustration"
            className="w-full px-5  object-contain"
          />
        </div>
        <div className="mt-6 max-w-[1280px] mx-auto small:hidden  grid grid-cols-1 gap-3">
        <div className="mt-6 max-w-[1280px] mx-auto small:hidden grid grid-cols-1 gap-3">
  {steps.map((step, index) => (
    <div key={index}>
      <img
        src={step.img}
        alt={`Step ${index + 1}`}
        className=" px-5 w-[150px] mx-auto object-contain"
      />
      <div className="px-5">
      <h3 className="text-lg font-bold text-center text-yellow-400 mb-1">
        {step.title.split(" ")[0]}{" "}
        <span className="text-white">
          {step.title.split(" ").slice(1).join(" ")}
        </span>
      </h3>
      <p className="text-sm  text-center text-white">{step.desc}</p>
      </div>
    </div>
  ))}
</div>

        </div>
      </div>
    </div>
  );
};

export default Section_one;
